import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { motion } from 'framer-motion';
export function ThemeToggle() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <motion.button onClick={toggleTheme} className="relative p-2 rounded-full bg-accent hover:bg-accent/80 transition-colors" whileTap={{
    scale: 0.95
  }} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`} data-id="element-217">
      <motion.div initial={false} animate={{
      rotate: theme === 'light' ? 0 : 180
    }} transition={{
      duration: 0.5,
      ease: 'easeInOut'
    }} className="w-5 h-5 relative" data-id="element-218">
        {theme === 'light' ? <i className="bi bi-sun absolute inset-0 text-foreground text-xl" data-id="element-219"></i> : <i className="bi bi-moon absolute inset-0 text-foreground text-xl" data-id="element-220"></i>}
      </motion.div>
    </motion.button>;
}